<template>
    <div>
        <div class="border-divider"></div>
        <BLink class="button-sidebar mt-3"
           :href="mainUrl + '/admin/accounts'"
           @click="handleClick($event, ['admin/accounts'])"
           :class="{'active': isActive(['admin']), 'button-sidebar-min': isSmallDesign}"
           v-ripple>
            <i class="mi-dvr mi-1-3x"></i>
            <span :class="{'ml-1': !isSmallDesign}">Superadmin</span>
        </BLink>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import sidebarMixin from "@/mixins/sidebar/mixin";

export default {
    name: 'AdminSidebar',
    computed: {
        ...mapGetters(['isSmallDesign']),
    },
    mixins: [sidebarMixin],
}
</script>